import NewPassword from "components/ResetPassword/NewPassword";
import React from "react";

const NewPasswords = () => {
  return <NewPassword />;
};

export default NewPasswords;
